import client from '@/apis/aniftyBackend/client';

export const masterSearch = async (
  keyword: string,
): Promise<{ creations: Array<any>, users: Array<any>, tags: Array<any> } | null> => {
  const response = await client.get(
    `/api/master_search?keyword=${keyword}`
  );

  return response.data;
};
